import * as React from "react"

function AtencionIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15.51 15.27"
      {...props}
    >
      <defs>
        <style>{".cls-1{fill:#003da6}"}</style>
      </defs>
      <g id="Capa_2" data-name="Capa 2">
        <g id="Capa_1-2" data-name="Capa 1">
          <path
            className="cls-1"
            d="M14.6 7.13a1.54 1.54 0 01-.24.81l-2.7 4.19a2 2 0 00-.3 1v1.22H8.21v-3.51a1.41 1.41 0 01.39-1L12 6.46a.45.45 0 01.64 0 .45.45 0 010 .63L9.82 9.88a.43.43 0 000 .63.45.45 0 00.64 0l2.83-2.79a1.37 1.37 0 00.4-.89V2.2a.47.47 0 01.44-.47.51.51 0 01.33.13.45.45 0 01.14.32zm-7.3 7.24H4.14v-1.22a2 2 0 00-.29-1l-2.7-4.21a1.45 1.45 0 01-.24-.81V2.2a.47.47 0 01.44-.47.51.51 0 01.33.13.45.45 0 01.14.32v4.65a1.28 1.28 0 00.4.89L5 10.5a.45.45 0 00.64 0 .43.43 0 000-.63L2.86 7.09a.43.43 0 010-.63.45.45 0 01.64 0L6.9 9.8a1.34 1.34 0 01.4 1zm7.79-13.15a1.36 1.36 0 00-1-.38 1.38 1.38 0 00-1.31 1.36v3.31a1.4 1.4 0 00-1.42.31L8 9.17l-.21.24a2.25 2.25 0 00-.21-.24L4.14 5.82a1.37 1.37 0 00-1.41-.31V2.18a1.33 1.33 0 00-.42-1 1.36 1.36 0 00-1-.38A1.38 1.38 0 000 2.2v4.93a2.37 2.37 0 00.38 1.29l2.7 4.19a1 1 0 01.16.54v1.67a.45.45 0 00.45.45h8.13a.45.45 0 00.45-.45v-1.67a1 1 0 01.16-.54l2.7-4.19a2.46 2.46 0 00.38-1.29V2.18a1.33 1.33 0 00-.42-1"
          />
          <path
            className="cls-1"
            d="M5.3 2.73h1.41a.45.45 0 00.45-.45V.89h1.18v1.39a.46.46 0 00.46.45h1.41v1.16H8.8a.46.46 0 00-.46.45v1.38H7.16V4.34a.45.45 0 00-.45-.45H5.3zm-.45 2.05h1.41v1.39a.45.45 0 00.45.45H8.8a.45.45 0 00.45-.45V4.78h1.41a.45.45 0 00.45-.44V2.28a.45.45 0 00-.45-.45H9.25V.45A.45.45 0 008.8 0H6.71a.45.45 0 00-.45.45v1.38H4.85a.46.46 0 00-.46.45v2.06a.45.45 0 00.46.44"
          />
        </g>
      </g>
    </svg>
  )
}

export default AtencionIcon
